import React, { useState } from 'react'
import styles from './addcard.module.css'
import './override.css'
import { Button, Col, DatePicker, Form, Row, Typography } from 'antd';
import { AntdInput } from '../../components';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PaymentCardsMiddleware from '../../store/Middlewares/PaymentCardsMiddleware';
import AlertAction from '../../store/Actions/AlertActions';

function AddCard() {
    const style = { background: '#0092ff', padding: '8px 0' };
    const { Text } = Typography;
    const [form] = Form.useForm();

    const navigate = useNavigate()
    const onFinish = (values) => {
        console.log('Success values:', values);
        // values?.expiry_date(moment(dateString).format('YYYY-MM-DD'))
    };
    const dispatch = useDispatch();
    const [CardNumber, setCardNumber] = useState('');
    const [ExpiryDate, setExpiryDate] = useState(null)
    const [SelectedDate, setSelectedDate] = useState('Date');
    const [CVV, setCVV] = useState('');
    const [ExpiryDateModal, setExpiryDateModal] = useState(false)
    const [date, setDate] = useState(new Date());

    const onPressStoreCard = (values) => {
        let userData = {
            card_number: CardNumber,
            exp_date: ExpiryDate,
            cvc: CVV,
        };

        if (!CardNumber || !ExpiryDate || !CVV) {
            dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please fill all fields' }))
        }
        else {
            dispatch(PaymentCardsMiddleware.storeCards(userData))
                .then((data) => {
                    dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
                    navigate(-2)
                })
                .catch((error) => {
                    console.log(error);
                });
            // console.log('onPressStoreCard',userData)
        }
    };

    return (
        <div className={styles.mainCont}>
            <Text className={styles.cardText}>Add Card</Text>
            <Form
                name="basic"
                form={form}
                initialValues={{ remember: true }}
                onFinish={onPressStoreCard}
                // onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <div className={styles.inputCont}>
                    <div className={styles.inputItem}>
                        <AntdInput
                            maxLength={16}
                            placeholder={'16 Digit Card Number'}
                            name={'card_number'}
                            label='Card Number'
                            rules={[{ require: true, type: 'Number', message: 'Please enter card number' },
                            {
                                pattern: /^[\d]{16}$/,
                                message: "Enter 16 digits card number",
                            },]}
                            onChange={(e) => setCardNumber(e.target.value)}
                        />
                    </div>
                    <div className={styles.inputItem}>
                        <Form.Item labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ width: '100%' }}
                            className='dateInput'
                            name='expiry_date'
                            label={<p className={styles.label_style}>Expiry Date</p>}>
                            <DatePicker
                                disabledDate={(current) => {
                                    let customDate = moment().format("MM/YYYY");
                                    return current && current < moment(customDate, "MM/YYYY");
                                }
                                }
                                format={"MM/YYYY"}
                                name='expiry_date'
                                className={styles.input}
                                placeholder='Date'
                                onChange={(date, dateString) => setExpiryDate(dateString)}
                                picker='month' />
                        </Form.Item>
                    </div>
                </div>
                <div className={styles.inputCont}>
                    <div className={styles.inputItem}>
                        <AntdInput
                            maxLength={4}
                            placeholder={'CCV'}
                            name={'ccv'}
                            label='CCV'
                            rules={[{ require: true, type: 'Number', message: 'Please enter card number' }, {
                                pattern: /^(?:\d*)$/,
                                message: "CVV should contain just number",
                            },]}
                            onChange={(e) => setCVV(e.target.value)}
                        />
                    </div>
                    <div className={styles.inputItem}>
                        <AntdInput
                            placeholder={'John'}
                            name={'name'}
                            label="Card Holder's Name"
                            rules={[{ require: true, type: 'Number', message: 'Please enter card number' }]}
                        // onChange={(e) => set(e.target.value)}
                        />
                    </div>
                </div>
                <Form.Item >
                    <Button type="primary" htmlType="submit" className={styles.antdButton} onClick={() => {
                        // navigate('/subscription/AddCard/Payments')
                    }}>
                        Add Card
                    </Button>
                </Form.Item>
            </Form>
        </div>

    )
}

export default AddCard